import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { connect } from 'react-redux'
import { COLORES } from '../../../../../config/colores'
import { actualizarDatosParaMuiTable, actualizarDatosPorFechaCupo } from '../actions/TablaCamionesEnCircuitoActions'

const opciones = ['Todos', 'Del día', 'Vencidos', 'Adelantados', 'Autodescargables']

function CamionesEnCircuitoPorFechaCupo (props) {
  const [option, setOption] = useState(0)

  const actualizarTodos = () => {
    setOption(0)
    props.actualizarDatosPorFechaCupo(0)
  }

  const actualizarDatosDelDia = () => {
    setOption(1)
    props.actualizarDatosPorFechaCupo(1)
  }

  const actualizarVencidos = () => {
    setOption(2)
    props.actualizarDatosPorFechaCupo(2)
  }

  const actualizarAdelantados = () => {
    setOption(3)
    props.actualizarDatosPorFechaCupo(3)
  }

  const actualizarAutodescargables = () => {
    setOption(4)
    const autodescargables = true
    props.actualizarDatosPorFechaCupo(0, autodescargables)
  }

  const actualizar = (name, index) => {
    if (index === 0) { actualizarTodos() }
    if (index === 1) { actualizarDatosDelDia() }
    if (index === 2) { actualizarVencidos() }
    if (index === 3) { actualizarAdelantados() }
    if (index === 4) { actualizarAutodescargables() }
  }

  const renderButtons = () => {
    const buttons = opciones.map((b, i) => {
      return (
        <Button
          variant='contained'
          style={{
            backgroundColor: option === (i) ? COLORES.blue.primary : COLORES.grey.dark,
            color: 'white',
            margin: '1%',
            padding: '0 28px',
            whiteSpace: 'nowrap'
          }}
          key={i}
          size='small'
          onClick={() => { actualizar(b, i) }}
        >
          {b}
        </Button>
      )
    })
    return buttons
  }

  return (
    <div className='container-buttons-cdmd'>
      {renderButtons()}
    </div>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  actualizarDatosPorFechaCupo
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CamionesEnCircuitoPorFechaCupo)
